import { default as VuxDataCache, rootCache } from 'ivux-data-cache/src/index'

export default function(Vue, options = {}) {
    var { router, store, config } = options

    // install ivux-data-cache
    VuxDataCache(Vue, {
        router,
        // 根路径
        rootPath: config.pageName,
        // 全局缓存
        rootCache: config.globalCache,
        // 获取当前用户
        resolveUserId() {
            return store.state.user.info.id
        },
    })

    if (store) {
        store.subscribe((mutation, state) => {
            // 记忆用户tab浏览记录
            if (mutation.type == "setTagNavList") {
                rootCache.tagNavList = state.app.tagNavList
            }

            // userId可能发生了变化，重设rootCache
            if (mutation.type == "setUserInfo") {
                rootCache.setOptions()
            }
        })
    }
}